import React from 'react';
import CustomerShell from './CustomerShell';

export default function CustomerApp() {
  return <CustomerShell variant="legacy" />;
}


